import { useEffect } from 'react';

const useTouchPrefilledFields = ({ activeStep, activeType, formRef, isOAuthRegistration }) => {
  useEffect(() => {
    if (!isOAuthRegistration || !formRef.current || !activeType) {
      return;
    }

    const currentStep = activeType.steps?.[activeStep];

    if (!currentStep?.fields) {
      return;
    }
    requestAnimationFrame(() => {
      if (!formRef.current?.setFieldValueHandler) {
        return;
      }

      currentStep.fields.forEach(field => {
        const { hidden, name, value } = field;

        // Only touch fields that have a value and are visible
        if (value && !hidden) {
          // Setting field value with touchOnChange=true marks it as touched,
          // which triggers validation display
          formRef.current.setFieldValueHandler(name, value, true);
        }
      });
    });
  }, [activeStep, activeType, formRef, isOAuthRegistration]);
};

export default useTouchPrefilledFields;
